<template>
	<div class="">
		<div
			class="2xl:w-[1200px] xl:w-[1200px] lg:container md:container mb-[26px] h-[74px]   relative  mx-auto text-center leading-[74px]">
			<div class="flex items-center absolute top-[50%] left-0" style="transform: translateY(-50%);">
				<!-- <label class="text-[#101010]  mr-2">简体中文</label> -->

				<el-select v-model="value" :placeholder="langInfo.please_select" @change="changeLang">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<!-- <img class="size-2.5 mr-5" src="@/static/image/icon01.png" /> -->
			</div>
			<div class="text-[20px] font-bold text-[#1B2128] w-[70%] mx-auto truncate">{{title}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
				default: '',
			}

		},

		data() {
			return {
				options: [{
					value: 'zh',
					label: '' //中文
				}, {
					value: 'en',
					label: '' //英文
				}, {
					value: 'cht',
					label: '' //繁体
				}],
				value: 'zh',
				selectValue: "",
				langInfo: {}
			}
		},
		mounted() {
			this.value = localStorage.getItem('lang') || 'zh';
			this.langInfo = this.$store.getters['lang/getLangList']

			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				this.setNav()
			}
			this.getconfig()
		},
		methods: {
			
			getconfig() {
				this.$api.config({}).then((res) => {
			
					var link = document.querySelector("link[rel~='icon']");
					if (!link) {
						link = document.createElement('link');
						link.rel = 'icon';
						document.head.appendChild(link);
					}
					link.href = res.data.url_logo
				}).catch((error) => {
					
				})
			},
			
			setNav() {
				this.options[0].label = this.langInfo.zh
				this.options[1].label = this.langInfo.en
				this.options[2].label = this.langInfo.cht
			},
			// 设置语言
			changeLang(e) {
				console.log(e);
				this.selectValue = e
				this.dict_data_cq()
			},
			dict_data_cq() {
				this.$api.dict_data_cq({
					lang: this.selectValue
				}).then((res) => {
					console.log(res);
					if (res.code == 1) {
						this.value = this.selectValue
						this.selectValue = ""
						localStorage.setItem('lang', this.value)
						location.reload();
						this.getdict_data()
					} else {
						this.selectValue = localStorage.getItem('lang') || 'zh'
						this.value = localStorage.getItem('lang') || 'zh'
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}
				}).catch((error) => {
					this.selectValue = localStorage.getItem('lang') || 'zh'
					this.value = localStorage.getItem('lang') || 'zh'
					console.log("this.selectValue==" + this.selectValue);
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})

					this.langInfo = obj
					this.setNav()

					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
		}
	}
</script>

<style scoped>
	/deep/.el-input input {
		padding-right: 0;
		background-color: #f3fbff;
		border: 0;
		width: 100px;
		font-size: 15px !important;
	}
	.el-select-dropdown__item{
		font-size: 15px !important;
	}
</style>